import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'

export default class extends Component {
  render() {
    let header = [
      <a href="#/localMerchant/home">我的店铺</a>,
      <a href="#/localMerchant/myShop">商家等级</a>,
      '订单礼'
    ]

    return (
      <HeaderView title="订单礼" header={header}>
        <div style={{ padding: 40 }}>
          <img src="http://qnm.hunliji.com/o_1aa18knoq1a0110cnrc7p0nqg3h.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa18knoq1ga11r8n19bq1dt5umqi.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa18knor161hcq71ome78dhvsj.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa18knor1ni51ef018ej1d1q1fuvk.jpg" />
        </div>
      </HeaderView>
    )
  }
}
